import { render, staticRenderFns } from "./filter-project-parts.vue?vue&type=template&id=6326518e&scoped=true&"
import script from "./filter-project-parts.vue?vue&type=script&lang=ts&"
export * from "./filter-project-parts.vue?vue&type=script&lang=ts&"
import style0 from "./filter-project-parts.vue?vue&type=style&index=0&id=6326518e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6326518e",
  null
  
)

export default component.exports